import { render, staticRenderFns } from "./ResponsiveLogin.vue?vue&type=template&id=dc473af2&"
import script from "./ResponsiveLogin.vue?vue&type=script&lang=js&"
export * from "./ResponsiveLogin.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports